/* Fetches Shopify's product recommendations and replaces the section's
   shell with the rendered result.

   The request is deferred until the section is close to the viewport.
   Recommendations sit well below the fold on a product page, so fetching
   them at load competes with the images the shopper is actually looking
   at.

   Note: "Shipping Protection by Route" (or similar app add-on products)
   are stripped from the fetched markup below, since the Shopify
   recommendations endpoint can include them and they are not real
   product recommendations. */
(function () {
  var roots = document.querySelectorAll('[data-recommendations]');
  if (!roots.length) return;

  var EXCLUDED_KEYWORD = 'Shipping Protection';

  function load(root) {
    var base = root.getAttribute('data-url');
    var id = root.getAttribute('data-product-id');
    if (!base || !id) return;

    var url =
      base +
      '?section_id=' +
      encodeURIComponent(root.closest('[id^="shopify-section-"]').id.replace('shopify-section-', '')) +
      '&product_id=' +
      encodeURIComponent(id) +
      '&limit=' +
      encodeURIComponent(root.getAttribute('data-limit') || 10) +
      '&intent=' +
      encodeURIComponent(root.getAttribute('data-intent') || 'related');

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations unavailable');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-recommendations]');

        if (!next) {
          root.remove();
          return;
        }

        // Remove any card matching the excluded keyword (e.g. Shipping
        // Protection add-on products) before checking if anything is left.
        next.querySelectorAll('li').forEach(function (li) {
          if (li.textContent.indexOf(EXCLUDED_KEYWORD) !== -1) {
            li.remove();
          }
        });

        // No recommendations is a normal outcome for a new or one-off
        // product. Leaving the empty shell in place keeps the page from
        // ending on a bare heading with nothing under it.
        if (!next.querySelector('.pb-card')) {
          root.remove();
          return;
        }

        root.innerHTML = next.innerHTML;

        // carousel.js has already run by now, so any track that arrived
        // with this markup needs wiring up explicitly.
        root.querySelectorAll('[data-carousel]').forEach(function (node) {
          node.dispatchEvent(new CustomEvent('pb:carousel-init', { bubbles: true }));
        });
      })
      .catch(function () {
        root.remove();
      });
  }

  if (!('IntersectionObserver' in window)) {
    roots.forEach(load);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    },
    { rootMargin: '400px 0px' }
  );

  roots.forEach(function (root) {
    observer.observe(root);
  });
})();